// extracted by mini-css-extract-plugin
export var label = "_hk-0";
export var treatmentCard = "_hk-1";